import React, { Component } from 'react'
import { Paper } from '@mui/material'
import { Box } from '@mui/system'
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import { GradientButton } from '../GradientButton';
import { Typography } from '@mui/material';
import EuroRoundedIcon from '@mui/icons-material/EuroRounded';

export class OffsetProjectCard extends Component {
    render() {
        return (
            <Paper variant="outlined" sx={{borderRadius:2,padding:2,display:"flex",justifyContent:"space-between", flexDirection:"column"}} >
                <Box>
                <img src={this.props.project.img} style={{width:"100%"}} alt=""/>
                <Box paddingTop={2} paddingBottom={4}>
                <Typography variant="h4" fontWeight={700} marginBottom={2}>
                    {this.props.project.heading}
                </Typography>

                <Stack direction="row" gap={1}>
                <PlaceOutlinedIcon fontWeight={900} fontSize="medium" />
                <Typography variant="body1" fontWeight={600}>{this.props.project.place}</Typography>
                </Stack>

                <Stack direction="row" gap={1} marginTop={1}>
                <EuroRoundedIcon fontWeight={900} fontSize="medium" />
                <Typography variant="body1" fontWeight={600}>{this.props.project.carbon}</Typography>
                </Stack>
                </Box>
                </Box>
                

            <Stack  gap={2}>
                <Button fullWidth variant="outlined" borderRadius={10}>
                    View Details
                </Button>

                <GradientButton textTransformtype="capitalize" fullWidth borderRadius={4}>
                Offset Your Carbon Footprint
                </GradientButton>
                </Stack>
            </Paper>
        )
    }
}

export default OffsetProjectCard;